import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-success-save-edit',
  templateUrl: './dialog-success-save-edit.component.html',
  styleUrls: ['./dialog-success-save-edit.component.css']
})
export class DialogSuccessSaveEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
